<div
  [ngClass]="{
    'bg-white': isHovering,
    'bg-green-100 text-green-600': !isHovering && status === WarrantyStatus.Active,
    'bg-red-100 text-red-600': !isHovering && status === WarrantyStatus.Expired,
    'bg-yellow-100 text-yellow-600': !isHovering && status === WarrantyStatus.Extended,
    'bg-blue-100 text-blue-600': !isHovering && status === WarrantyStatus.Future,
  }"
  class="flex flex-row items-center justify-center gap-1 px-[10px] py-[4px] rounded-full"
>
  <div
    class="w-2 h-2 rounded-full"
    [ngClass]="{
      'bg-green-600': status === WarrantyStatus.Active,
      'bg-red-600': status === WarrantyStatus.Expired,
      'bg-yellow-600': status === WarrantyStatus.Extended,
      'bg-blue-600': status === WarrantyStatus.Future,
    }"
  ></div>
  <p class="p-0 m-0 font-medium text-xs whitespace-nowrap">
    {{
      (extendedTranslate ? 'ASSETS_TREE.TREE_SECTION.TREE_VIEW.WARRANTY_STATUS.' : 'ASSETS_TREE.DETAILS_SECTION.WARRANTIES.STATUS.') +
        status.toUpperCase() | translate
    }}
  </p>
</div>
